
import moment from 'moment';

export const onlydates = (val) => (moment(val,'MM/DD/YYYY',true)._isValid || moment(val,'MM-DD-YYYY',true)._isValid); 


// WEBPACK FOOTER //
// ./src/utils/functions/onlydates.js